export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'zonghe-fuwu',
    name: '综合服务',
    description: '一站式 aqdlt 综合解决方案，涵盖平台运营、技术支持和业务咨询',
    icon: 'ri-stack-line',
  },
  {
    slug: 'jishu-zhichi',
    name: '技术支持',
    description: '专业的技术团队为您提供全方位的 aqdlt 技术支持和系统维护',
    icon: 'ri-tools-line',
  },
  {
    slug: 'shangwu-hezuo',
    name: '商务合作',
    description: '开放共赢的 aqdlt 商务合作模式，助力合作伙伴快速成长',
    icon: 'ri-hand-heart-line',
  },
  {
    slug: 'xingye-zixun',
    name: '行业资讯',
    description: '最新的 aqdlt 行业动态、政策解读和市场趋势分析',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'chanpin-dongtai',
    name: '产品动态',
    description: 'aqdlt 产品更新、功能迭代和版本发布的最新信息',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'chenggong-anli',
    name: '成功案例',
    description: '真实的 aqdlt 客户案例，展示平台在各行业的实际应用效果',
    icon: 'ri-trophy-line',
  },
];